import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';
import StatusBadge from '../../components/StatusBadge';

const FILTERS = [
  { key: '', label: 'All' },
  { key: 'issued', label: 'Awaiting signature' },
  { key: 'signed', label: 'Signed' },
  { key: 'withdrawn', label: 'Withdrawn' },
];
const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

const Contracts = () => {
  const [status, setStatus] = useState('');
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setError('');
    try {
      const params = new URLSearchParams({ page: String(page) });
      if (status) params.set('status', status);
      if (q.trim()) params.set('q', q.trim());
      const res = await api(`/admin/contracts?${params}`, { auth: true });
      setData(res.data);
    } catch (err) {
      setError(err.message);
    }
  }, [status, q, page]);

  useEffect(() => { load(); }, [load]);

  const pages = data ? Math.max(1, Math.ceil(data.total / data.pageSize)) : 1;
  const count = (k) => (k ? (data && data.counts[k]) || 0 : data && Object.values(data.counts).reduce((a, b) => a + b, 0));

  return (
    <div>
      <h1 className="text-2xl font-bold">Contracts</h1>
      <p className="mt-1 text-sm text-muted">Issued by Ivipass when a candidate's contract is marked sent. Candidates sign from their Ivipass portal.</p>

      <div className="mt-6 flex flex-wrap items-center gap-2">
        {FILTERS.map((f) => (
          <button key={f.key} type="button" onClick={() => { setStatus(f.key); setPage(1); }}
            className={`rounded-full px-3 py-1.5 text-sm ${status === f.key ? 'bg-primary text-white' : 'bg-white text-muted hover:text-ink'}`}>
            {f.label} {data && <span className="opacity-70">({count(f.key)})</span>}
          </button>
        ))}
        <input className="wc-input ml-auto max-w-xs" placeholder="Search name, email or reference" value={q}
          onChange={(e) => { setQ(e.target.value); setPage(1); }} />
      </div>

      {error && <p className="mt-4 rounded-lg bg-danger-soft p-3 text-sm text-danger">{error}</p>}

      <div className="wc-card mt-4 overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-line text-xs uppercase tracking-wide text-muted">
            <tr>
              <th className="px-4 py-3">Candidate</th>
              <th className="px-4 py-3">Position</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Issued</th>
              <th className="px-4 py-3">Signed</th>
            </tr>
          </thead>
          <tbody>
            {data && data.items.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-muted">No contracts here yet.</td></tr>
            )}
            {data && data.items.map((c) => (
              <tr key={c._id} className="border-b border-line last:border-0 hover:bg-cream/60">
                <td className="px-4 py-3">
                  <Link to={`/staff/contracts/${c._id}`} className="font-medium text-primary hover:underline">
                    {(c.candidate && c.candidate.fullName) || c.reference}
                  </Link>
                  <div className="text-xs text-muted">{c.candidate && c.candidate.email}</div>
                </td>
                <td className="px-4 py-3">{(c.terms && c.terms.positionTitle) || '—'}</td>
                <td className="px-4 py-3">
                  <StatusBadge status={c.status} />
                  {c.missing && c.missing.length > 0 && (
                    <div className="mt-1 text-xs text-danger">Not ready: {c.missing.length} item{c.missing.length === 1 ? '' : 's'} missing</div>
                  )}
                </td>
                <td className="px-4 py-3">{fmt(c.issuedAt || c.createdAt)}</td>
                <td className="px-4 py-3">{fmt(c.signing && c.signing.signedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {pages > 1 && (
        <div className="mt-4 flex items-center justify-end gap-2 text-sm">
          <button type="button" className="wc-btn-ghost" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</button>
          <span className="text-muted">Page {page} of {pages}</span>
          <button type="button" className="wc-btn-ghost" disabled={page >= pages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </div>
  );
};

export default Contracts;
